var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fenximenu"}},[_c('span',{staticClass:"aaa",class:{ active: _vm.now == 1 },on:{"click":function($event){return _vm.clickMenu(1)}}},[_vm._v("\n    当年费用\n  ")]),_vm._v(" "),_c('span',{staticClass:"aaa",class:{ active: _vm.now == 2 },on:{"click":function($event){return _vm.clickMenu(2)}}},[_vm._v("\n    当月费用\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2112db0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fenxi/feiyong/fenxiMenu.vue
// module id = null
// module chunks = 